import React, { useState, useLayoutEffect } from 'react';
import { isNull } from 'lodash';
import { notification, Button } from 'antd';

import Modal from 'antd/lib/modal/Modal';
import ProductSegmentPredicateComponent from '@Modules/insight/productSegment/component/ProductSegmentPredicateComponent';

function ModalEventFilterSelector(props) {
  const [predicates, setPredicates] = useState(null);

  useLayoutEffect(() => {
    if (!props.isModalVisible) {
      setPredicates(null);
      return;
    }
    if (!props.currentPredicate) {
      setPredicates(null);
      return;
    }
    const currentPredicates = Object.assign({}, props.currentPredicate);
    currentPredicates.eventPredicates = (
      currentPredicates.predicates ||
      currentPredicates.attributeFilters ||
      []
    ).filter(Boolean);
    currentPredicates.eventConjunction = currentPredicates.conjunction || 'AND';
    currentPredicates.type = 'BEHAVIOUR';
    setPredicates(currentPredicates);
  }, [props.isModalVisible, props.currentPredicate]);

  const readOnly = !!props.readOnly;

  return (
    <Modal
      width={1080}
      title={readOnly ? 'Event conditions (view only)' : 'Event Filter'}
      centered
      visible={props.isModalVisible}
      onOk={() => {
        if (readOnly) {
          props.onCancelHandler?.();
          return;
        }
        const currentPredicates = Object.assign({}, predicates);
        currentPredicates.conjunction =
          currentPredicates.eventConjunction || 'AND';

        currentPredicates.predicates = currentPredicates.eventPredicates.filter(
          (item) => item.attribute
        );

        const isValid = currentPredicates.predicates.every((item) => {
          switch (item.operator) {
            case 'IS_NOT_EMPTY':
              return true;
            case 'EQUAL_TO':
            case 'ONE_OF':
            case 'STARTS_WITH':
            case 'ENDS_WITH':
            case 'CONTAINS':
            case 'MATCHES_REGEX':
              return (
                'stringValue' in item &&
                !isNull(item.stringValue) &&
                item.stringValue !== ''
              );
            case 'BETWEEN':
              switch (item.relativeDateType) {
                case 'DATE':
                  return (
                    (!isNull(item.greaterThan) && item.greaterThan !== '') ||
                    (!isNull(item.lessThan) && item.lessThan !== '')
                  );
                case 'LAST-LAST':
                case 'NEXT-NEXT':
                case 'LAST-NEXT':
                  if (
                    !item.relativeDateDurationFrom &&
                    !item.relativeDateDurationTo
                  ) {
                    return false;
                  }

                  if (
                    item.relativeDateDurationFrom &&
                    (!item.relativeDateValueFrom ||
                      item.relativeDateValueFrom === '' ||
                      isNull(item.relativeDateValueFrom))
                  ) {
                    return false;
                  }
                  if (
                    item.relativeDateDurationTo &&
                    (!item.relativeDateValueTo ||
                      item.relativeDateValueTo === '' ||
                      isNull(item.relativeDateValueTo))
                  ) {
                    return false;
                  }

                  if (
                    !item.relativeDateDurationFrom &&
                    item.relativeDateValueFrom
                  ) {
                    return false;
                  }

                  if (
                    !item.relativeDateDurationTo &&
                    item.relativeDateValueTo
                  ) {
                    return false;
                  }

                  return true;
                default:
                  return (
                    (!isNull(item.greaterThan) && item.greaterThan !== '') ||
                    (!isNull(item.lessThan) && item.lessThan !== '')
                  );
              }
            default:
              break;
          }
        });

        if (!isValid) {
          notification.error({
            key: 'Error',
            description: 'Please fill all fields or remove unused filters',
            placement: 'bottomRight',
          });
        } else {
          props.onOkHandler(currentPredicates);
        }
      }}
      okButtonProps={readOnly ? { style: { display: 'none' } } : undefined}
      cancelText={readOnly ? 'Close' : undefined}
      footer={
        readOnly
          ? [
              <Button
                key="close"
                type="primary"
                onClick={() => props.onCancelHandler?.()}
              >
                Close
              </Button>,
            ]
          : undefined
      }
      onCancel={props.onCancelHandler}
    >
      <div>
        {predicates ? (
          <ProductSegmentPredicateComponent
            isFunnel={true}
            deepInIntegration={props.deepInIntegration}
            selectEventDisabled={true}
            readOnly={readOnly}
            type="HAS_DONE_EVENT"
            predicate={predicates}
            events={props.events}
            handleChangePredicate={(changedPredicate) => {
              if (!readOnly) {
                setPredicates(changedPredicate);
              }
            }}
            fetchRecommendEventAttributes={props.fetchRecommendEventAttributes}
            recommendEventAttributes={props.recommendEventAttributes}
          />
        ) : null}
      </div>
    </Modal>
  );
}

export default ModalEventFilterSelector;
